import React from 'react'
import { Grid as BaseGrid, styled } from '@mui/material'
import { Button as BaseButton } from '@chilecompra/react-kit/components'

export const Root = styled('div')`
  box-sizing: border-box;
  padding: 0 0 130px;
  width: 100%;
`

export const DesktopNavigation = styled('div')`
  display: flex;
  justify-content: space-between;

  ${props => props.theme.breakpoints.down('sm')} {
    justify-content: center;
    margin: 0;
  }
`
export const SubTitle = styled('h1')`
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 18px;
  font-weight: 600;
  width: ${props => props.width};

  ${props => props.theme.breakpoints.down('xs')} {
    text-align: center;
  }
`

export const Divided = styled('hr')`
  border: 1px solid ${props => props.theme.palette.gray[90]};
  margin: ${props => props.margin};
  width: ${props => props.width || 'auto'};
`

export const Section = styled(({ margin, maxWidth, padding, ...props }) => <BaseGrid {...props} />)`
  margin: ${props => props.margin || 'initial'};
  max-width: ${props => props.maxWidth};
  padding: ${props => props.padding || 'initial'};

  label {
    color: ${props => props.theme.palette.brand.black1};
    text-align: left;
  }
`

export const Strong = styled('span')`
  font-weight: bold;
`

export const Title = styled('h3')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 27px;
  font-weight: 700;
  line-height: 31px;
  margin: 50px 0;
  text-align: left;

  ${props => props.theme.breakpoints.down('sm')} {
    margin: 20px 0;
    font-size: 22px;
    line-height: 27px;
  }
`

export const Instructions = styled('p')`
  color: ${props => props.theme.palette.custom.charcoal};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 20px;
  margin: -20px 0 20px 0;

  ${props => props.theme.breakpoints.down('sm')} {
    text-align: left;
    margin-top: 11px;
  }
`

export const ExternalLink = styled('a')`
  color: ${props => props.theme.palette.brand.primary};

  &:hover {
    text-decoration: underline;
  }
`

export const Divider = styled('hr')`
  color: ${props => props.theme.palette.custom.dividerGrey};
  border-bottom-width: 0;
  border-left-width: 0;
  border-right-width: 0;
  border-top-width: 1px;
  height: 1px;
`

export const SubInput = styled('p')`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${props => props.theme.palette.custom.baliHai};
  margin-top: -20px;
  text-align: left;
`

export const MobileButtons = styled(BaseButton)`
  flex-grow: 1;
  width: 100%;
`

export const MobileNavigation = styled('div')`
  align-items: stretch;
  display: flex;
  flex-direction: column;
  gap: 18px;
  justify-content: center;
  width: 100%;

  ${props => props.theme.breakpoints.down('sm')} {
    margin: 0 auto;
    width: 90%;
  }
  ${props => props.theme.breakpoints.between('sm', 'lg')} {
    width: 60%;
  }
`
